import { Send } from 'lucide-react'

import { useState } from 'react'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

interface SendTestDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onSend: (email: string) => void
}

export const SendTestDialog = ({ open, onOpenChange, onSend }: SendTestDialogProps) => {
  const [email, setEmail] = useState('')

  const handleSend = () => {
    if (!email) return
    onSend(email)
    setEmail('')
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Send className="w-5 h-5" />
            Send Test Email
          </DialogTitle>
          <DialogDescription>
            Enter an email address to send a test preview of this campaign.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <Label htmlFor="email">Email Address</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              autoFocus
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleSend} disabled={!email}>
            Send Test
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
